/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import { ASYNC_KEY } from '../utils/General';
import _ from 'lodash';
import {logout} from "../core/authentication";
const axios = require('axios');

const headers = {
  'Access-Control-Allow-Origin': "*",
  'Access-Control-Allow-Credentials': 'true',
  'Accept': 'application/json',
  'Content-Type': 'application/json',
}

const GetRequest = (url, params) => {
  // console.log('>token',localStorage.getItem(ASYNC_KEY.ACCESS_TOKEN))
  headers.Authorization = `Bearer ${localStorage.getItem(ASYNC_KEY.ACCESS_TOKEN)}`
  try {
    const response = axios.get(`${url}`, {
      headers: headers
      , params,
    })
    response.catch(error => {
      if ( _.get(error, 'response.status') === 401) {
        logout()
      } else {
        // Handle else
      }
    })
    return response
    //resolve(response);
  } catch (error) {
    
  }
};

const PostRequest = (url, data, params) => {
  headers.Authorization = `Bearer ${localStorage.getItem(ASYNC_KEY.ACCESS_TOKEN)}`
  try {
    const response = axios({
      method: 'post',
      url: `${url}`,
      headers: headers,
      params,
      data: data

    });
    return response;
  } catch (error) {
    
  }
};

const PutRequest = (url, params, data) => {
  headers.Authorization = `Bearer ${localStorage.getItem(ASYNC_KEY.ACCESS_TOKEN)}`
  try {
    const response = axios({
      method: 'put',
      url: `${url}`,
      headers: headers,
      params,
      data: data
    });
    return response;
  } catch (error) {
   
    return error;
  }
};

const DeleteRequest = (url,data, params) => {
  headers.Authorization = `Bearer ${localStorage.getItem(ASYNC_KEY.ACCESS_TOKEN)}`
  try {
    const response = axios({
      method: 'delete',
      url: `${url}`,
      headers: headers,
      data,
      params
    });
    return response;
  } catch (error) {
    
  }
};

const DeleteRequestWithBody = (url, data, params) => {
  headers.Authorization = `Bearer ${localStorage.getItem(ASYNC_KEY.ACCESS_TOKEN)}`
  try {
    const response = axios({
      method: 'delete',
      url: `${url}`,
      headers: headers,
      data,
      params
    });
    return response;
  } catch (error) {
    
  }
};

const GetResultObject = (result, key, code = 200, success) => {
  if(_.get(result, 'data.code') == code) {
    success(
      _.get(result, `data.${key}`)
      ,
      {
        pages:_.get(result, 'data.data.totalPages')
        , size: _.get(result, 'data.data.numberOfElements')
        , total: _.get(result, 'data.data.totalElements')
      }
    )
  }else{
    
  }
}



export * from './Endpoints'
export {
  GetResultObject,
  GetRequest,
  PostRequest,
  DeleteRequest,
  DeleteRequestWithBody,
  PutRequest,
};
